import { Photo } from '@app/models';

export class PhotoGalleryItemRetailer{
    code: string;
    name: string;
}

export class PhotoGalleryItemStore{
    code: string;  
    name: string;  
}

export class PhotoGalleryItemOperation{
    id: number;
    name: string;
    typeOfMission: string;
    source: string;
}

export class PhotoGalleryItem { 
    day: number;
    retailer: PhotoGalleryItemRetailer;
    store: PhotoGalleryItemStore;
    operation: PhotoGalleryItemOperation;
    tagName: string;
    modelName: string;
    urlThumbnail: string;
    urlPicture: string;
    uniqid: string;
    
    static FromPhoto(p: Photo): PhotoGalleryItem {
        let photo = new PhotoGalleryItem();
        photo.day = p.referenceDate;
        photo.retailer = {
            code: p.retailerCode, 
            name: p.retailerName 
        }
        photo.store = {
            code: p.storeCode,
            name: p.storeName
        }
        photo.operation = {
            id: p.operationId,
            name: p.operationName,
            typeOfMission: p.typeOfMission,
            source: p.operationSource
        }           
        photo.tagName = p.tagName;
        photo.modelName = p.modelName;
        photo.urlThumbnail = p.urlThumbnail;
        photo.urlPicture = p.urlPicture;
        photo.uniqid = p.uniqid;
        return photo;
    }
}
